//noScroll
class ReserveHover {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const HoverReserve = document.querySelector('.hovReserve');
    const ReserveContent = document.querySelector('.reserveContent');

    // ご予約
    // ===================================================
    HoverReserve.addEventListener('mouseover', () => {
      HoverReserve.classList.add("is-open")
      ReserveContent.classList.add("is-open")
    }, false);
    HoverReserve.addEventListener('mouseleave', () => {
      ReserveContent.classList.remove("is-open")
      HoverReserve.classList.remove("is-open")
    }, false);

    ReserveContent.addEventListener('mouseover', () => {
      ReserveContent.classList.add("is-open")
      HoverReserve.classList.add("is-open")
    }, false);
    ReserveContent.addEventListener('mouseleave', () => {
      ReserveContent.classList.remove("is-open")
      HoverReserve.classList.remove("is-open")
    }, false);
    
  }
}
